<template>
  <b-card no-body>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <!-- Per Page -->
        <!-- Search -->
        <b-col cols="12">
          <b-row class="align-items-center">
            <b-col lg="3">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model.trim="searchQuery"
                  class="d-inline-block round"
                  placeholder="Search by code, name, description"
                />
              </div>
            </b-col>
            <b-col lg="3">
              <div
                class="d-flex align-items-center justify-content-end mt-1 m-lg-0"
              >
                <!-- <multiselect
                  label="text"
                  class="search round"
                  :searchable="true"
                  track-by="id"
                  :show-labels="false"
                  v-model="searchType"
                  :options="$Utils.CONSTANTS.CONFIG_TYPE_NOTIFY"
                /> -->

                <Select4
                  v-model="searchType"
                  :options="{
                    isSearch: true,
                    value: 'id',
                    all: true,
                    label: 'text',
                    data: $Utils.CONSTANTS.CONFIG_TYPE_NOTIFY,
                    fields: [{ field: 'text', label: 'Text' }],
                  }"
                />
              </div>
            </b-col>
            <b-col lg="3">
              <div
                class="d-flex align-items-center justify-content-end mt-1 m-lg-0"
              >
                <!-- <multiselect
                  label="text"
                  class="search round"
                  :searchable="true"
                  track-by="id"
                  :show-labels="false"
                  :allow-empty="false"
                  v-model="roleType"
                  :options="$Utils.CONSTANTS.CONFIG_ROLE_TYPE_NOTIFY"
                /> -->
                <Select4
                  v-model="roleType"
                  :options="{
                    isSearch: true,
                    value: 'id',
                    all: true,
                    label: 'text',
                    data: $Utils.CONSTANTS.CONFIG_ROLE_TYPE_NOTIFY,
                    fields: [{ field: 'text', label: 'Text' }],
                  }"
                />
              </div>
            </b-col>
            <b-col
              cols="12"
              md="3"
              class="d-flex align-items-center justify-content-center justify-content-lg-start px-0 py-1 my-1 m-lg-0"
            >
              <b-button variant="primary" @click="fetchData()" class="round">
                {{ $t("search") }}
              </b-button>
            </b-col>
          </b-row>
        </b-col>

        <b-col
          lg="12"
          class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
        >
          <b-button variant="primary" class="round" @click="New()">
            {{ $t("addSettings") }}
          </b-button>
        </b-col>
        <!-- <b-col
          cols="12"
          md="12"
          class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
        >
          <b-button variant="primary" class="round" @click="New()">
            {{ $t("addSettings") }}
          </b-button>
        </b-col> -->
      </b-row>
    </div>
    <b-table
      v-if="itemsTable"
      responsive
      hover
      :items="itemsTable"
      :fields="fields"
      >.
      <template v-slot:cell()="data">
        <span v-b-tooltip.hover :title="data.value">{{ data.value }}</span>
      </template>
      <template #cell(type)="row">
        {{
          row.item.type == $Utils.CONSTANTS.USE_TYPE_NOTIFY_A.WEB.id
            ? $Utils.CONSTANTS.USE_TYPE_NOTIFY_A.WEB.text
            : row.item.type == $Utils.CONSTANTS.USE_TYPE_NOTIFY_A.EMAIL.id
            ? $Utils.CONSTANTS.USE_TYPE_NOTIFY_A.EMAIL.text
            : $Utils.CONSTANTS.USE_TYPE_NOTIFY_A.SMS.text
        }}
      </template>
      <template #cell(status)="row">
        {{ row.item.status == 0 ? "Chưa kích hoạt" : "Đã kích hoạt" }}
      </template>
      <template #cell(actions)="row">
        <b-button variant="primary" class="mr-1" size="sm" @click="Edit(row)">
          <feather-icon icon="EditIcon" />
        </b-button>
      </template>
    </b-table>
    <b-row class="pl-2 pr-2 pb-1 pt-1 border-top">
      <b-col
        cols="12"
        md="6"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <label>{{ $t("showing") }} </label>
        <v-select
          v-model="perPage"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="perPageOptions"
          :clearable="false"
          style="min-width: 60px"
          class="per-page-selector select-size-sm d-inline-block ml-50 mr-1"
        />
        <label>{{ $t("entries") }}</label>
      </b-col>
      <b-col
        cols="12"
        md="6"
        class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
      >
        <b-pagination
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="totalRows"
        />
      </b-col>
    </b-row>
    <b-modal
      id="modal-edit"
      v-model="modalShow"
      no-close-on-backdrop
      size="xl"
      title="Notifications"
      @ok="handleOk"
    >
      <validation-observer ref="simpleRules">
        <b-row>
          <b-col cols="12" lg="6">
            <validation-provider
              name="Config type"
              #default="{ errors }"
              :rules="{ required: 'required', vselect: true }"
            >
              <b-form-group :state="errors.length > 0 ? false : null">
                <label
                  >{{ $t("configType") }}<span class="required">*</span>
                </label>

                <v-select
                  label="text"
                  :disabled="isEdit"
                  :class="{ 'is-invalid': !!errors.length }"
                  v-model="currentItem.configType"
                  :options="$Utils.CONSTANTS.CONFIG_TYPE_NOTIFY"
                  :clearable="false"
                >
                  <small class="text-danger">{{ errors[0] }}</small>
                </v-select>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" lg="6">
            <b-form-group>
              <label
                >{{ $t("roleType") }}<span class="required">*</span>
              </label>

              <span class="d-flex justify-center" style="margin-top: 10px">
                <b-form-radio
                  class="mr-4"
                  v-model="isWR1"
                  :disabled="isEdit"
                  name="some-radios"
                  :value="true"
                >
                  WR1
                </b-form-radio>
                <b-form-radio
                  v-model="isWR1"
                  :disabled="isEdit"
                  name="some-radios"
                  :value="false"
                >
                  Customer
                </b-form-radio>
              </span>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <label for="input-name"
              >{{ $t("name") }}<span class="required">*</span>
            </label>

            <b-form-group>
              <div class="d-flex input-name">
                <!-- <multiselect
                  id="input-name"
                  label="text"
                  :disabled="isEdit"
                  :allow-empty="false"
                  track-by="id"
                  :searchable="true"
                  :show-labels="false"
                  class="d-inline-block"
                  v-model="currentItem.notifyCate"
                  :options="notifyCatesAdd"
                /> -->

                <Select4
                  id="input-name"
                  v-model="currentItem.notifyCate"
                  :disabled="isEdit"
                  placeholder="Select name"
                  :options="{
                    isSearch: true,
                    value: 'id',
                    label: 'text',
                    all: true,
                    data: notifyCatesAdd,
                    fields: [
                      { field: 'id', label: 'id' },

                      { field: 'text', label: 'text' },
                    ],
                  }"
                />
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="12" v-if="currentItem && currentItem.configType.id == 1">
            <validation-provider
              name="Subjects"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label>
                  {{ $t("Subjects") }}<span class="required">*</span>
                </label>
                <b-form-textarea
                  :state="errors.length > 0 ? false : null"
                  v-model="currentItem.subjects"
                  :placeholder="$t('subjects')"
                />
                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-group label="">
              <b-form-checkbox switch v-model="currentItem.STATUS">
                {{ $t("status") }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" v-if="totalRender > 0">
            <validation-provider
              name="Description"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label>
                  {{ $t("description") }}<span class="required">*</span>
                </label>
                <b-form-textarea
                  :state="errors.length > 0 ? false : null"
                  v-model="currentItem.description"
                  :placeholder="$t('description')"
                />
                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <validation-provider
              name="Template"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label
                  >{{ $t("template") }}<span class="required">*</span>
                </label>
                <b-form-textarea
                  :state="errors.length > 0 ? false : null"
                  v-model="currentItem.template"
                  :placeholder="$t('template')"
                />
                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" v-if="currentItem.configType.id == 0">
            <validation-provider
              name="Template VN"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label
                  >{{ $t("templateVn") }}<span class="required">*</span>
                </label>
                <b-form-textarea
                  :state="errors.length > 0 ? false : null"
                  v-model="currentItem.templateVn"
                  :placeholder="$t('templateVn')"
                />
                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-group label="">
              <b-form-checkbox switch v-model="livePreview">
                {{ $t("livePreview") }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-col cols="12" v-if="livePreview">
          <b-card>
            <div v-html="currentItem.template"></div>
          </b-card>
        </b-col>
        <b-row v-if="currentItem && currentItem.configType.id == 0">
          <b-col cols="6">
            <b-form-group label="">
              <b-form-checkbox switch v-model="livePreviewVN">
                {{ $t("livePreviewVn") }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>

        <b-col cols="12" v-if="livePreviewVN">
          <b-card>
            <div v-html="currentItem.templateVn"></div>
          </b-card>
        </b-col>
      </validation-observer>
      <template #modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="btn round"
          @click="modalShow = false"
        >
          {{ $t("cancel") }}
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          @click="handleOk"
          class="btn round"
        >
          {{ isEdit ? $t("update") : $t("save") }}
        </b-button>
      </template>
    </b-modal>
  </b-card>
</template>

<script>
import {
  reactive,
  ref,
  watchEffect,
  watch,
  computed,
} from "@vue/composition-api";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";
import { useUtils as useI18nUtils } from "@core/libs/i18n";

export default {
  components: { vSelect, ValidationProvider, ValidationObserver },
  watch: {
    "$i18n.locale": function (newVal, oldVal) {
      this.renderComponent = false;
      this.fields = [];
      this.$nextTick(() => {
        // Add the component back in
        this.fields = [
          {
            key: "code",
            sortable: false,
            label: this.$i18n.t("code"),
          },
          {
            key: "name",
            sortable: false,
            label: this.$i18n.t("name"),
          },
          {
            key: "description",
            label: this.$i18n.t("description"),
            sortable: false,
          },
          {
            key: "template",
            label: this.$i18n.t("template"),
            sortable: false,
          },
          {
            key: "type",
            label: this.$i18n.t("type"),
            sortable: false,
          },
          {
            key: "status",
            label: this.$i18n.t("status"),
            sortable: false,
            tdClass: "w-5",
          },
          {
            key: "actions",
            label: this.$i18n.t("actions"),
            class: "text-center",
          },
        ];

        this.renderComponent = true;
      });
    },
  },

  setup(props, cxt) {
    const { t } = useI18nUtils();
    const perPageOptions = ref([10, 25, 50, 100]);
    const perPage = ref(10);
    const searchQuery = ref("");
    const roleType = ref({ id: "0", text: "WR1" });
    const searchType = ref("");
    const notifyCates = ref([]);

    const currentPage = ref(1);
    const totalRows = ref(0);
    const initialState = {
      configType: { id: 0, text: "WEB" },
      STATUS: true,
      description: "",
      notifyCate: "",
      roleType: 0,
      subjects: "",
      template: "",
      templateVn: "",
      type: "",
    };
    const currentItem = reactive({ ...initialState });

    const items = ref([]);
    const isEdit = ref(false);
    const isWR1 = ref(true);
    const livePreview = ref(false);
    const livePreviewVN = ref(false);
    const notifyCatesAdd = ref([]);
    const totalRender = ref(1);
    const modalShow = ref(false);
    watch(
      [perPage, currentPage],
      ([currentValueA, currentValueB], [oldValueA, oldValueB]) => {
        // console.log(oldValueA);
        oldValueA !== currentValueA ? (currentPage.value = 1) : "";
        fetchData();
      }
    );
    const fields = reactive([
      {
        key: "code",
        sortable: false,
        label: t("code"),
        tdClass: "w-5",
      },
      {
        key: "name",
        sortable: false,
        label: t("name"),
        tdClass: "w-5",
      },
      {
        key: "description",
        label: t("description"),
        sortable: false,
      },
      {
        key: "template",
        label: t("template"),
        sortable: false,
      },
      {
        key: "type",
        label: t("type"),
        sortable: false,
      },
      {
        key: "status",
        label: t("status"),
        sortable: false,
        tdClass: "w-5",
      },
      {
        key: "actions",
        label: t("actions"),
        class: "text-center",
      },
    ]);
    // watch([searchQuery, isWR1], ([count, prevCount], [newVal, oldVal]) => {
    //   if (count == "" && count !== prevCount) fetchData();
    // });
    fetchNotifyCate();
    fetchData();

    function checkIsWR() {
      if (isWR1.value) {
        reset();
        notifyCatesAdd.value = notifyCates.value.filter(
          (e) => e.role_type == 0
        );
      } else {
        reset();

        notifyCatesAdd.value = notifyCates.value.filter(
          (e) => e.role_type == 1
        );
      }
    }
    function New() {
      reset();
      isWR1.value = roleType.value.id == 0 ? true : false;
      checkIsWR();
      isEdit.value = false;
      modalShow.value = true;
    }

    watch([searchQuery, isWR1], ([count, newVal], [prevCount, oldVal]) => {
      if (count == "" && count !== prevCount) fetchData();
      if (newVal !== oldVal) checkIsWR();
    });

    function reset() {
      Object.assign(currentItem, initialState);
    }

    async function handleOk() {
      if (!currentItem.notifyCate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Please check the input Name!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      var validate = await cxt.refs.simpleRules.validate().then((success) => {
        return success;
      });

      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Please check the input data!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      if (isEdit.value) {
        cxt.root.$loading.show();
        const data = {
          id: currentItem.id,
          code: currentItem.notifyCate.id,
          description: currentItem.description,
          name: currentItem.notifyCate.text,
          roleType: isWR1.value ? 0 : 1,
          status: currentItem.STATUS ? "1" : "0",
          subjects: currentItem.subjects,

          template: currentItem.template,
          templateVn: currentItem.templateVn,
          type: currentItem.configType.id,
        };

        useJwt
          .put("notifyConfig", data)
          .then((response) => {
            modalShow.value = false;
            fetchData();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("success"),
                text: this.$i18n.t("successfullyUpdated"),
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("error"),
                text: this.$i18n.t("errorSystem"),
                icon: "XIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => cxt.root.$loading.hide());
      } else {
        cxt.root.$loading.show();

        const data = {
          code: currentItem.notifyCate.id,
          description: currentItem.description,
          name: currentItem.notifyCate.text,

          roleType: isWR1.value ? 0 : 1,

          status: currentItem.STATUS ? "1" : "0",
          template: currentItem.template,

          subjects: currentItem.subjects,

          templateVn: currentItem.templateVn || "",

          type: currentItem.configType.id,
        };
        useJwt
          .post("notifyConfig", data)
          .then((response) => {
            if (response.data.result == "1") {
              modalShow.value = false;
              fetchData();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$i18n.t("success"),
                  text: this.$i18n.t("successfullyUpdated"),
                  icon: "CheckSquareIcon",
                  variant: "primary",
                },
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$i18n.t("error"),
                  text: response.data.message,
                  icon: "XIcon",
                  variant: "danger",
                },
              });
            }
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("error"),
                text: this.$i18n.t("errorSystem"),
                icon: "XIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => cxt.root.$loading.hide());
      }
    }
    async function Edit(row) {
      totalRender.value++;
      if (row.item) {
        isEdit.value = true;
        Object.assign(currentItem, {
          id: row.item.id,
          notifyCate: notifyCates.value.filter((e) => e.id == row.item.code)[0],
          description: row.item.description,
          template: row.item.template,
          templateVn: row.item.template_vn,
          subjects: row.item.subjects,
          configType: cxt.root.$Utils.CONSTANTS.CONFIG_TYPE_NOTIFY.filter(
            (e) => e.id == row.item.type
          )[0],
          STATUS: row.item.status == 0 ? false : true,
        });

        isWR1.value = row.item.role_type == 0 ? true : false;

        cxt.root.$nextTick();

        modalShow.value = true;
      }
    }
    function fetchNotifyCate() {
      useJwt.get("masterData?data=NotifyCate").then((response) => {
        notifyCates.value = response.data.result;
      });
    }

    function fetchData() {
      modalShow.value = false;

      items.value = [];
      cxt.root.$loading.show();
      useJwt
        .get("notifyConfig", {
          params: {
            search: searchQuery.value,
            roleType: roleType.value.id,
            type: searchType.value?.id || -1,
            page: currentPage.value,
            pageSize: perPage.value,
          },
        })
        .then((response) => {
          if (response.data.message == "success!") {
            items.value = response.data.result;
            totalRows.value = response.data.meta.total;
          }
        })
        .finally(() => cxt.root.$loading.hide());
    }

    const itemsTable = computed(() => items.value);
    const invalidFeedback = computed(() => {
      return !!currentItem.notifyCate;
    });
    const notifyCatesFind = computed(() =>
      notifyCates.value.filter((e) => e.role_type == roleType.value.id)
    );

    return {
      perPageOptions,
      perPage,
      currentPage,
      totalRows,
      items,
      itemsTable,
      fields,
      currentItem,
      livePreview,
      livePreviewVN,
      isEdit,
      searchQuery,
      notifyCatesFind,
      fetchData,
      searchType,
      notifyCates,
      roleType,
      isWR1,
      totalRender,

      notifyCatesAdd,
      modalShow,
      // actions
      invalidFeedback,
      handleOk,
      New,
      Edit,
      reset,
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.td-height {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 300px;
}
.w-5 {
  width: 150px;
}

.round .multiselect__tags {
  border-radius: 1.5rem;
}
.input-name .input-group-text {
  border-radius: 0.357rem 0 0 0.357rem !important;
}

.nameConfig .multiselect__tags {
  border-radius: 0px 5px 5px 0px !important;
}
</style>
